#!/usr/bin/env node
import fs from 'fs';
import path from 'path';
import { parseRoutesFromFile } from '../route-parser';

const args = process.argv.slice(2);

function getArg(name: string, defaultValue: string): string {
  const index = args.indexOf(name);
  if (index !== -1 && args[index + 1]) {
    return args[index + 1];
  }
  return defaultValue;
}

const appPath = getArg('--app-path', './client/src/app.tsx');
const outDir = path.resolve(process.cwd(), getArg('--out-dir', './dist'));
const filename = getArg('--filename', 'page-routes.json');

try {
  // page-routes 不带 basePath 前缀（basePath 为空），供日志服务消费
  const routes = parseRoutesFromFile(appPath, '');
  if (!fs.existsSync(outDir)) {
    fs.mkdirSync(outDir, { recursive: true });
  }
  const outPath = path.resolve(outDir, filename);
  fs.writeFileSync(outPath, JSON.stringify(routes, null, 2));
  console.log(`[page-routes] Generated ${outPath} (${routes.length} routes)`);
} catch (error) {
  console.warn('[page-routes] Failed to generate page-routes.json, writing empty fallback:', error);
  if (!fs.existsSync(outDir)) {
    fs.mkdirSync(outDir, { recursive: true });
  }
  fs.writeFileSync(path.resolve(outDir, filename), JSON.stringify([], null, 2));
}
